import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import Search from 'src/sections/dashboard/patients/patient-listing-search';
import { accordianSummaryCSS } from './css-classes';
import { PanelName } from './card-types';
import { boolean } from 'yup';

type Search = {
  placeholder: string;
  searchData: string;
  setSearchData: React.Dispatch<React.SetStateAction<string | ''>>;
  loadingSearch: boolean;
};

type Props = {
  expanded: string;
  handleChange: (
    panelName: PanelName
  ) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
  title: string;
  summary: React.ReactNode;
  requiredSearch: boolean;
  searchProperties: Search;
  panelName: PanelName;
  haveData: boolean;
  areRecordsAvailable: () => boolean;
};

function TextBankCard(props: Props) {
  const {
    expanded = false,
    handleChange = () => () => {},
    title,
    requiredSearch = false,
    summary,
    searchProperties,
    panelName,
    haveData = false,
    areRecordsAvailable = () => boolean,
  } = props;
  return (
    <Accordion
      expanded={expanded === panelName}
      onChange={(event, isExpanded) => handleChange(panelName)(event, isExpanded)}
      disableGutters
      sx={{ border: '1px solid #E5E7EB' }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography variant="body1">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {requiredSearch && (
          <Box p={2}>
            <Search
              placeholder="Enter CPT code"
              setSearchData={searchProperties?.setSearchData}
              searchData={searchProperties?.searchData}
              loading={searchProperties?.loadingSearch}
            />
            {!haveData && searchProperties?.searchData?.length == 0 && (
              <Typography variant="caption">
                Please enter at least three character to search...
              </Typography>
            )}
            {!areRecordsAvailable() &&
              searchProperties.searchData.length !== 0 &&
              !searchProperties.loadingSearch && (
                <Typography
                  variant="body2"
                  textAlign={'center'}
                  mt={2}
                >
                  No records found
                </Typography>
              )}
          </Box>
        )}
        <Box sx={accordianSummaryCSS}>{summary}</Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default TextBankCard;
